import { render, staticRenderFns } from "./ProductCustomField.vue?vue&type=template&id=b96a5b52&scoped=true"
import script from "./ProductCustomField.vue?vue&type=script&lang=js"
export * from "./ProductCustomField.vue?vue&type=script&lang=js"
import style0 from "./ProductCustomField.vue?vue&type=style&index=0&id=b96a5b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96a5b52",
  null
  
)

export default component.exports